(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["_product-measurement-comment"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('measurement-upload')) {
    customElements.define(
      'measurement-upload',
      class MeasurementUpload extends HTMLElement {
        connectedCallback() {
          this.input = this.querySelector('.measurement-upload__input');
          this.img = this.querySelector('.measurement-upload__img');
          this.removeBtn = this.querySelector('.measurement-upload__remove');
          if (!this.input || this.bound) return;
          this.bound = true;
          this.input.addEventListener('change', this.onChange.bind(this));
          if (this.removeBtn) {
            this.removeBtn.addEventListener('click', this.onRemove.bind(this));
          }
        }
        onChange() {
          const file = this.input.files && this.input.files[0];
          if (!file || file.type.indexOf('image/') !== 0) {
            this.clear();
            return;
          }
          const reader = new FileReader();
          reader.onload = (e) => {
            if (this.img) this.img.src = e.target.result;
            this.classList.add('has-image');
          };
          reader.readAsDataURL(file);
        }
        onRemove(e) {
          e.preventDefault();
          e.stopPropagation();
          this.clear();
        }
        clear() {
          this.input.value = '';
          if (this.img) this.img.removeAttribute('src');
          this.classList.remove('has-image');
        }
      }
    );
  }
  } catch(e) { console.error(e); }
})();

})();
